import { addPaymentInfoSchema } from './schemas/add-payment-info'
import { addShippingInfoSchema } from './schemas/add-shipping-info'
import { addToCartSchema } from './schemas/add-to-cart'
import { addToWishlistSchema } from './schemas/add-to-wishlist'
import { beginCheckoutSchema } from './schemas/begin-checkout'
import { pageViewSchema } from './schemas/page-view'
import { purchaseSchema } from './schemas/purchase'
import { removeFromCartSchema } from './schemas/remove-from-cart'
import { selectItemSchema } from './schemas/select-item'
import { selectPromotionSchema } from './schemas/select-promotion'
import { userDataSchema } from './schemas/user-data'
import { viewCartSchema } from './schemas/view-cart'
import { viewItemSchema } from './schemas/view-item'
import { viewItemListSchema } from './schemas/view-item-list'
import { viewPromotionSchema } from './schemas/view-promotion'
import { viewSearchResultsSchema } from './schemas/view-search-results'

export const ga4EventSchemas = {
  page_view: pageViewSchema,
  user_data: userDataSchema,
  view_item: viewItemSchema,
  view_item_list: viewItemListSchema,
  select_item: selectItemSchema,
  select_promotion: selectPromotionSchema,
  view_promotion: viewPromotionSchema,
  view_search_results: viewSearchResultsSchema,
  add_to_wishlist: addToWishlistSchema,
  add_to_cart: addToCartSchema,
  remove_from_cart: removeFromCartSchema,
  view_cart: viewCartSchema,
  begin_checkout: beginCheckoutSchema,
  add_shipping_info: addShippingInfoSchema,
  add_payment_info: addPaymentInfoSchema,
  purchase_back_bone: purchaseSchema,
}
